import { PractitionerView } from '@dreryk/egabinet-personnel-frontend-api';
import {
   DayOfWeek,
   EncounterMode,
   ReservationPreference,
   Status,
   TimeOfDay,
} from '@dreryk/egabinet-waitlist-frontend-api';

import { HealthcareProviderLocation } from '~libs.shared.healthcare-provider-location';

import { ServicesControllerItem } from './controllers/servicesController/ServicesController.types';

export type WaitlistFilterPanelPatientAvailability = {
   dayOfWeek: DayOfWeek | null;
   timesOfDay: TimeOfDay[];
};

export type WaitlistFilterPanelFormBean = {
   healthcareProviderLocations: HealthcareProviderLocation[];
   practitioners: PractitionerView[];
   reservationPreference: ReservationPreference | null;
   statuses: Status[];
   urgent: boolean;
   encounterModes: EncounterMode[];
   services: ServicesControllerItem[];
   patientAvailabilityDayOfWeek: DayOfWeek | null;
   patientAvailabilityTimesOfDay: TimeOfDay[];
};

export enum WaitlistFilterPanelSearchParam {
   HEALTHCARE_PROVIDER_LOCATION = 'mus',
   PRACTITIONER = 'specjalista',
   RESERVATION_PREFERENCE = 'priorytet',
   STATUS = 'status',
   URGENT = 'pilne',
   ENCOUNTER_MODE = 'typ-wizyty',
   SERVICES = 'usluga',
   PATIENT_AVAILABILITY_DAY_OF_WEEK = 'dzien',
   PATIENT_AVAILABILITY_TIMES_OF_DAY = 'pora-dnia',
}

export enum WaitlistFilterPanelStorageKey {
   HEALTHCARE_PROVIDER_LOCATION = 'healthcareProviderLocations',
   PRACTITIONER = 'practitioners',
   RESERVATION_PREFERENCE = 'reservationPreference',
   STATUS = 'status',
   URGENT = 'urgent',
   ENCOUNTER_MODE = 'encounterModes',
   SERVICES = 'services',
   PATIENT_AVAILABILITY_DAY_OF_WEEK = 'dayOfWeek',
   PATIENT_AVAILABILITY_TIMES_OF_DAY = 'timesOfDay',
}
